export const COMPONENT_DATA_KEY = '__wg_component__';

export default {
    getComponent () {
        return this.getComponentList()[0] || null;
    },
    setComponent (component) {
        this.data(COMPONENT_DATA_KEY, component);
    },
    removeComponent () {
        this.data(COMPONENT_DATA_KEY, null);
    },
    getComponentList () {
        return (
            this
                .map((index, element) => (
                    $(element).data(COMPONENT_DATA_KEY) || null
                ))
                .filter((index, component) => component)
        );
    },
    closestComponents (selector) {
        return this.closest(selector).getComponentList() || [];
    },
    findComponents (selector) {
        return this.find(selector).getComponentList() || [];
    },
    getAttributes (filterFn = ()=>true) {
        const attributes = {};

        if( this.length ) {
            this[0].attributes
                .filter(filterFn)
                .forEach(function( index, attr ) {
                    attributes[ attr.name ] = attr.value;
                });
        }

        return attributes;
    },
    dataAttr (key, value) {
        this.data(key, value);
        this.attr(`data-${key}`, value);
    }
};